module.exports = __webpack_public_path__ + "img/184.product_inventory.19413d82.svg";